import { useAsyncFn } from 'react-use';
import { useApolloClient } from '@apollo/react-hooks';
import { processGuestAmendment } from './processGuestAmendment';
import { SelfServiceAPI } from 'types';

interface Data extends SelfServiceAPI.CreateGuestAmendment.Request {
  bookingId: string;
}

const useCreateGuestAmendment = () => {
  // TODO: remove client once acceptAmendment is updated
  const client = useApolloClient();
  const [{ loading, error }, createGuestAmendment] = useAsyncFn((data: Data) => processGuestAmendment(client, data), [client]);

  return {
    createGuestAmendment,
    loading,
    error: !!error,
  };
};

export default useCreateGuestAmendment;
